function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  width: ",
        ";\n  height: ",
        ";\n  background-color: ",
        ";\n  \n  @media (prefers-color-scheme: dark) {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  aspect-ratio: 16/9;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n  z-index: 10;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  width: 2.5rem;\n  height: 2.5rem;\n  border: 2px solid var(--border-gray-300, #d1d5db);\n  border-top: 2px solid var(--border-blue-500, #3b82f6);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  text-align: center;\n  padding: 0.5rem;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--text-gray-500, #6b7280);\n  \n  @media (prefers-color-scheme: dark) {\n    color: var(--text-gray-400, #9ca3af);\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  margin-top: 0.5rem;\n  padding: 0.25rem 0.75rem;\n  font-size: 0.75rem;\n  background-color: var(--bg-blue-500, #3b82f6);\n  color: white;\n  border-radius: 9999px;\n  transition: background-color 0.2s;\n  \n  &:hover {\n    background-color: var(--bg-blue-600, #2563eb);\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background-color: #000;\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  right: 2px;\n  bottom: 2px;\n  padding: 8px;\n  background-color: rgba(0, 0, 0, 0.6);\n  border-radius: 9999px;\n  color: white;\n  transition: opacity 0.2s, background-color 0.2s;\n  z-index: 20;\n  \n  &:hover {\n    background-color: rgba(0, 0, 0, 0.8);\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// 스타일 컴포넌트 정의
export var Container = styled.div(_templateObject(), function(props) {
    return typeof props.width === 'number' ? "".concat(props.width, "px") : props.width;
}, function(props) {
    return typeof props.height === 'number' ? "".concat(props.height, "px") : props.height;
}, function(props) {
    return props.hasError ? 'var(--bg-gray-200, #e5e7eb)' : 'transparent';
}, function(props) {
    return props.hasError ? 'var(--bg-gray-800, #1f2937)' : 'transparent';
});
export var VideoContainer = styled.div(_templateObject1());
export var LoadingOverlay = styled.div(_templateObject2());
export var Spinner = styled.div(_templateObject3());
export var ErrorContainer = styled.div(_templateObject4());
export var ErrorMessage = styled.p(_templateObject5());
export var RetryButton = styled.button(_templateObject6());
export var VideoWrapper = styled.div(_templateObject7());
export var StyledVideo = styled.video(_templateObject8());
export var FullscreenButton = styled.button(_templateObject9());
